'use client';
import Logo from '@/components/global/Logo';
import { Motion } from '@/components/global/utils/Motion';
import { GroqImage } from '@/helpers/Image';
import { GROQButton, GROQImage } from '@/sanity/lib/definitions';
import { customRichTextComponent, richTextComponent } from '@/sanity/sanityPortableText';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CTAButton } from '@/shadcn/ui/button';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';

interface IMinsterBezel {
  image: GROQImage;
  title: PortableTextBlock[];
}

export default function MinsterBezelSection({
  image,
  title,
}: IMinsterBezel) {

  return (
    <section id="minster-bezel-section" className="container lg:max-w-none flex flex-col-reverse lg:flex-row items-center gap-[2rem] lg:gap-[11.62rem] pt-[12.88rem] lg:pt-0 bg-white px-0">
      <div className="w-full h-[54.4rem] lg:w-1/2 lg:h-full lg:overflow-hidden translate-y-[.1rem] lg:translate-y-0">
        {image && (
          <GroqImage
            src={image}
            alt="Common Questions Image"
            className="!w-full !h-full !object-cover rotate-[-90deg] lg:rotate-0"
            quality={100}
          />
        )}
      </div>
      <div
        className="flex flex-col gap-[4rem] w-full lg:w-[78.875rem] px-[2rem] lg:px-0 items-center lg:items-start
        prose-headings:text-black prose-headings:uppercase prose-headings:leading-[110%] lg:prose-headings:leading-[120%] prose-headings:mb-0 prose-headings:text-center lg:prose-headings:text-left
        prose-em:font-[300]"
      >
        {title && (
          <PortableText value={title} components={customRichTextComponent({
            block: {
              normal: ({ children }) => (
                <p className="text-black/[72%] text-[2rem] leading-[160%] font-[300] mb-0 max-w-[50rem] text-center lg:text-left">{children}</p>
              ),
              small: ({ children }) => (
                <p className="text-black/[72%] tracking-[0.53625rem] text-[1.625rem] uppercase leading-[120%] lg:leading-[100%] font-[300] mb-0 text-center lg:text-left max-w-[41rem] lg:max-w-none">{children}</p>
              ),
            },
          })} />
        )}
      </div>
    </section>
  );
}
